let currUrl = window.location.href;
let debug = currUrl.indexOf('192.168') > -1;

const REQUEST_URL = debug ? 'http://ehall.sxphc.cn' : 'http://ehall.sxphc.cn';
const MICRO_APP_URL = debug ? 'http://192.168.1.247:8183' : 'http://jkttb.itdaka.cn:8083'
const PLAN_URL = debug ? 'http://192.168.1.247:9001' : 'http://jkttb.itdaka.cn:8082'
const STATUS_ERR = "0";
const STATUS_OK = "1";
import {Message} from 'element-ui'
//结果处理
const resultHandle = (resultData, cb) => {
  switch (resultData.data.status) {
    case 1:
      cb(resultData.data)
      break;
    default:
      Message(resultData.data.msg)
  }
}
module.exports = {
  STATUS_ERR,
  STATUS_OK,
  REQUEST_URL,
  MICRO_APP_URL,
  PLAN_URL,
  debug,
  resultHandle
};



// WEBPACK FOOTER //
// ./src/common/js/api_config.js